(() => {
  const scope = document.getElementById('pflege-product-page');
  if (!scope) return;
  const $ = selector => scope.querySelector(selector);
  const $$ = selector => [...scope.querySelectorAll(selector)];
  const config = $('#pf-cart-config');
  const preview = config.dataset.mode === 'preview';
  const root = config.dataset.root || '/';
  const form = $('#PflegeProductForm'), quantity = $('#PflegeQuantity');
  const imageDialog = $('#pf-image-dialog');
  let busy = false, dialogFocus, previousOverflow = '';
  const clampQuantity = value => Math.max(1, Math.min(99, Math.floor(Number(value) || 1)));
  $$('[data-pf-zoom]').forEach(button => button.addEventListener('click', () => {
    dialogFocus = button; previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden'; imageDialog.showModal();
    imageDialog.querySelector('.pf-dialog-scroll').scrollTo(0,0);
  }));
  $('.pf-dialog-close').addEventListener('click', () => imageDialog.close());
  imageDialog.addEventListener('close', () => {document.body.style.overflow = previousOverflow; dialogFocus?.focus({preventScroll:true});});
  imageDialog.addEventListener('click', event => {if(event.target === imageDialog){const r=imageDialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)imageDialog.close();}});
  const tabs = $$('.pf-toc-tabs [role="tab"]');
  const mobileTrigger = $('#PflegeSubject');
  const mobileOptions = $('#PflegeSubjectOptions');
  const subjectButtons = $$('[data-pf-subject]');
  const setSubjectMenu = open => {
    mobileTrigger.setAttribute('aria-expanded', String(open));
    mobileOptions.hidden = !open;
  };
  const chooseSubject = index => {
    tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      document.getElementById(tab.getAttribute('aria-controls')).hidden = !active;
    });
    const sourceIcon = tabs[index].querySelector('.pf-subject-icon');
    mobileTrigger.querySelector('.pf-subject-icon').style.cssText = sourceIcon.style.cssText;
    $('#PflegeSubjectName').textContent = tabs[index].getAttribute('aria-label');
    subjectButtons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    setSubjectMenu(false);
    const selected = tabs[index], rail = selected.parentElement;
    if (rail.clientWidth) {
      const itemBounds = selected.getBoundingClientRect(), railBounds = rail.getBoundingClientRect();
      if (itemBounds.left < railBounds.left) rail.scrollLeft += itemBounds.left - railBounds.left;
      else if (itemBounds.right > railBounds.right) rail.scrollLeft += itemBounds.right - railBounds.right;
    }
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => chooseSubject(index));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault(); chooseSubject(next); tabs[next].focus();
    });
  });
  mobileTrigger.addEventListener('click', () => setSubjectMenu(mobileOptions.hidden));
  mobileTrigger.addEventListener('keydown', event => {
    if (event.key === 'ArrowDown') {
      event.preventDefault(); setSubjectMenu(true);
      subjectButtons.find(button => button.getAttribute('aria-pressed') === 'true').focus();
    }
  });
  subjectButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      chooseSubject(index); mobileTrigger.focus({preventScroll:true});
    });
    button.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowDown') next = (index + 1) % subjectButtons.length;
      if (event.key === 'ArrowUp') next = (index - 1 + subjectButtons.length) % subjectButtons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = subjectButtons.length - 1;
      if (next !== undefined) {event.preventDefault(); subjectButtons[next].focus();}
    });
  });
  $('.pf-toc-mobile').addEventListener('keydown', event => {
    if (event.key === 'Escape') {setSubjectMenu(false); mobileTrigger.focus({preventScroll:true});}
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.pf-toc-mobile')) setSubjectMenu(false);
  });
  $('.pf-toc-mobile').addEventListener('focusout', event => {
    if (!event.currentTarget.contains(event.relatedTarget)) setSubjectMenu(false);
  });
  $$('[data-pf-quantity]').forEach(button => button.addEventListener('click', () => {
    quantity.value = clampQuantity(Number(quantity.value) + Number(button.dataset.pfQuantity));
  }));
  quantity.addEventListener('change', () => { quantity.value = clampQuantity(quantity.value); });
  const variant = $('#PflegeVariant');
  const selectedAddon = () => $('[data-pf-addon]:checked');
  const updatePurchase = () => {
    const available = preview || variant?.selectedOptions[0]?.dataset.available === 'true';
    $$('[data-pf-add]').forEach(button => {
      button.disabled = busy || !available;
      button.textContent = busy ? 'Wird hinzugefügt…' : available ? (selectedAddon()?.value ? 'Beide in den Warenkorb' : 'In den Warenkorb') : 'Nicht verfügbar';
    });
    if (variant) $$('[data-pf-price]').forEach(node => {node.textContent = variant.selectedOptions[0]?.dataset.price || '';});
  };
  variant?.addEventListener('change', updatePurchase);
  $$('[data-pf-addon]').forEach(input => input.addEventListener('change', updatePurchase));
  $$('[data-pf-variant]').forEach(radio => radio.addEventListener('change', () => {
    if (radio.checked && variant) {variant.value = radio.value; updatePurchase();}
  }));

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy) return;
    const q = clampQuantity(quantity.value); quantity.value = q;
    busy = true; updatePurchase();
    const error = $('.pf-form-error'); error.hidden = true; error.textContent = '';
    try {
      if (!window.__mbc) throw new Error('Der Warenkorb wird geladen. Bitte versuche es gleich noch einmal.');
      const addon = selectedAddon();
      if (preview) {
        await window.__mbc.add('pflege', 'spiral', q);
        if (addon?.value) await window.__mbc.add(addon.value, addon.dataset.format, q);
      }
      else {
        if (!variant?.value) throw new Error('Bitte wähle ein Buchformat aus.');
        const items = [{id:variant.value,quantity:q}];
        if (addon?.value) {
          if (!addon.dataset.variantId) throw new Error('Dieses zusätzliche Buch ist nicht verfügbar. Bitte wähle eine andere Option.');
          items.push({id:addon.dataset.variantId,quantity:q});
        }
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Das Hinzufügen hat nicht geklappt. Bitte versuche es noch einmal.');
        await window.__mbc.render(); window.__mbc.open();
      }
    } catch (problem) {error.textContent = problem.message; error.hidden = false;}
    finally {busy = false; updatePurchase();}
  });
  updatePurchase();
  const sticky = $('.pf-sticky-buy');
  new IntersectionObserver(entries => {
    const entry = entries[0];
    sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
  },{threshold:0}).observe(form);

  const reviewSection = $('#recensioni');
  if (reviewSection) {
    const list = $('.pf-review-list'), reviews = $$('.pf-review-row');
    const search = $('#PfReviewSearch');
    const more = $('.pf-review-more');
    let visibleLimit = 5;
    const renderReviews = () => {
      const query = search.value.trim().toLocaleLowerCase('de');
      const matches = reviews.filter(row => row.textContent.toLocaleLowerCase('de').includes(query));
      reviews.forEach(row => {row.hidden = true;});
      matches.forEach((row,index) => {list.appendChild(row);row.hidden = index >= visibleLimit;});
      more.hidden = matches.length <= visibleLimit;
      $('.pf-review-empty').hidden = matches.length > 0;
      $('#PfReviewStatus').textContent = `${Math.min(visibleLimit,matches.length)} von ${matches.length} Bewertungen angezeigt`;
    };
    search.addEventListener('input', () => {visibleLimit=5;renderReviews();});
    more.addEventListener('click', () => {visibleLimit+=5;renderReviews();});
    renderReviews();
  }

})();
